import React from "react";
import dotProp from 'dot-prop-immutable';

/* Utilities */
import { trans } from '~/utilities';

export default function ProductSearchSelectFilter({ filters, filterKey, updateFilters, colClassName = 'col-12' }) {
    const filterIndex = filters?.indexOf(filters?.find(filter => filter.key === filterKey));
    const filter = filters[filterIndex]?.filters[0];

    const updateChoice = (key) => {
        updateFilters(dotProp.set(filters, `${filterIndex}.filters.0.choices`, choices => choices.map(choice => ({ ...choice, active: choice.key === key }))));
    }

    return (
        <>
            <input type="hidden" name={`${filterKey}[]`} value={filter?.choices?.find(choice => choice.active)?.key} />
            <div className={colClassName}>
                <label className="form-label" htmlFor={`vehicle_search_${filterKey}`}>
                    {trans(`app.content_block.vehicle_search.filter.${filterKey}.label`)}
                </label>
                <select id={`vehicle_search_${filterKey}`} className="custom-select" value={filter?.choices?.find(choice => choice.active)?.key} onChange={(e) => updateChoice(e.target.value)}>
                    <option value="">{trans(`app.content_block.vehicle_search.filter.${filterKey}.default_value`)}</option>
                    {filter?.choices?.map(choice => (
                        <option key={choice.key} value={choice.key}>{choice.name}</option>
                    ))}
                </select>
            </div>
        </>
    );
}
